module.exports = __webpack_public_path__ + "img/FoodSafety-swab.ca29710f.png";